import { CachedState } from 'Modules/Shared/reducers/cached.ts';
import { TemplateData } from 'Modules/Templates/types.d.ts';

export const getTemplateData = (state: CachedState): TemplateData =>
  state.getIn(['cached', 'templateData']);

export const getCopiedTemplate = (state: CachedState): TemplateData =>
  state.getIn(['cached', 'copiedTemplate']);
